document.addEventListener("DOMContentLoaded", function() {
  var menuTrigger = document.getElementById("HeaderProductMenu");
  var customMenu = document.querySelector(".custom-menu");

  if (menuTrigger && customMenu) {
    menuTrigger.addEventListener("mouseenter", function() {
      customMenu.classList.add("active");
    });

    menuTrigger.addEventListener("mouseleave", function() {
      customMenu.classList.remove("active");
    });
  }
});
